import { createSlice } from '@reduxjs/toolkit';

const initialState = false;

const isEditingEvaluacionesStateSlice = createSlice({
	name: 'isEditingEvaluacionesState',
	initialState,
	reducers: {
		setIsEditingEvaluacionesState: (state, action) => {
			return action.payload;
		}
	}
});

export const { setIsEditingEvaluacionesState } = isEditingEvaluacionesStateSlice.actions;
export default isEditingEvaluacionesStateSlice.reducer;
